import HistoryPredictions from 'components/HistoryPredictions';
import Loading from 'components/Loading';
import Page404 from 'pages/Error';
import PredictPage from 'pages/Jun88K36';
import MatchSchedule from 'pages/Jun88K36/MatchSchedule';
import RulePage from 'pages/Jun88K36/rule';
import { Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import favicon from './assets/images/favicon.ico';
import { SITE } from './config/config';

const favicons = {
  ok9: favicon
};

function Apps() {
  useEffect(() => {
    const faviconElement =
      document.querySelector("link[rel*='icon']") || document.createElement('link');
    faviconElement.type = 'image/png';
    faviconElement.rel = 'icon';
    faviconElement.href = favicons[SITE];
  }, []);

  return (
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route exact path="/" element={<PredictPage />} />
            <Route path="/prediction" element={<PredictPage />} />
            <Route path="/match" element={<MatchSchedule />} />
            <Route path="/rule" element={<RulePage />} />
            <Route path="/history" element={<HistoryPredictions />} />
            {/* <Route path="/prize-structure" element={<PrizeStructure />} /> */}
            {/* Add other routes here */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  );
}

export default Apps;
